<template>
  <!-- <v-card class="pa-10 ma-5 font-weight-light" elevation="3"> -->
  <v-table>
    <v-form ref="form" v-model="valid" v-on:submit.prevent="accessSubmit">
      <div v-if="$store.state.permission.superAdmin">
        <v-row>
          <v-col :lg="12" :md="12" :sm="12">
            <v-alert class="mt-6" text type="info" border="left">
              <div
                v-html="
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.accessStep.instructionPermissionOrganization'
                  )
                "
              />
            </v-alert>
          </v-col>
          <v-col :lg="6" :md="6" :sm="12">
            <p class="title">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.accessStep.organizationAccess'
                )
              }}
              <span class="red--text">*</span>
            </p>
            <!-- Admin Form -->
            <div class="paddingCard">
              <div :loading="loading" class="mx-auto org-card pt-1 ml-1">
                <v-list-item
                  v-for="(company, index) in listDetailCompany"
                  :key="company.companies._id"
                  class="org-card ma-3"
                >
                  <v-list-item-avatar size="75">
                    <v-img :src="company.companies.logo" />
                  </v-list-item-avatar>

                  <v-list-item-content v-model="selectedCompany">
                    <v-list-item-title
                      class="title"
                      :style="{ color: company.companies.themeColor }"
                      >{{ company.companies.title }}</v-list-item-title
                    >
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn
                      color="error"
                      class="title"
                      rounded
                      dark
                      large
                      @click="deleteCompany(company.companies._id)"
                    >
                      <v-icon left>mdi-delete</v-icon>
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.remove'
                        )
                      }}
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-btn
                      color="blue"
                      class="title"
                      outlined
                      rounded
                      dark
                      large
                      @click="selectCompany(company.companies._id, index)"
                    >
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.chooseGroup'
                        )
                      }}
                      <v-icon color="blue">mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-row justify="center">
                      <v-btn
                        rounded
                        color="primary"
                        class="ma-2 title px-7"
                        dark
                        large
                        @click="openDialog()"
                      >
                        <v-icon left>mdi-plus</v-icon>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.accessStep.addOrganization'
                          )
                        }}
                      </v-btn>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </div>
          </v-col>
          <v-col :lg="6" :md="6" :sm="12">
            <p class="title">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.accessStep.WhichMajorAccess'
                )
              }}
            </p>
            <v-autocomplete
              class="title"
              v-show="select"
              v-model="userGroupSelectByAdmin"
              :rules="groupRules"
              :items="userGroupAllAtIndex[indexSelectIdForSearch].user_groups"
              item-text="title"
              item-value="_id"
              append-icon="search"
              chips
              small-chips
              multiple
              rounded
              outlined
              :placeholder="
                $vuetify.lang.t(
                  '$vuetify.courseManagement.accessStep.ChooseGroupOrFaculty'
                )
              "
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeByAdmin(data.item)"
                  >{{ data.item.title }}</v-chip
                >
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </div>
      <div v-if="$store.state.permission.superAdmin">
        <v-row>
          <v-col>
            <div class="my-2 float-right">
              <v-btn
                color="primary"
                class="px-12 ma-2 title"
                large
                rounded
                @click="accessSubmit"
              >
                <v-icon left>mdi-check</v-icon>
                {{
                  $vuetify.lang.t('$vuetify.courseManagement.accessStep.save')
                }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-divider
        v-if="$store.state.permission.superAdmin"
        class="mb-10"
      ></v-divider>
      <!-- <v-card outlined class="pb-5"> -->
      <!-- -->
      <v-row justify="center">
        <!-- <v-dialog
          v-model="dialogFullReport"
          fullscreen
          persistent
          hide-overlay
          transition="dialog-bottom-transition"
        >-->
        <!-- <v-card outlined> -->
        <!-- <v-toolbar flat dark color="rgb(51, 97, 137)">
              <v-toolbar-title>
                <v-icon left>mdi-finance</v-icon>
                {{$vuetify.lang.t('$vuetify.courseManagement.courseList.studentListInCourse')}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="closeDialogFullReport">
                <v-icon>mdi-close</v-icon>
              </v-btn>
        </v-toolbar>-->
        <v-card-text>
          <div>
            <v-row>
              <!-- <v-col
                class="display-1 font-weight-medium black--text mx-5"
              >Learner List of the Course</v-col>-->
            </v-row>

            <v-row>
              <!-- <v-col lg="3" md="3" cols="12">
                    <div class="md-border pa-5 ma-5">
                      <div class="filter-header">
                        <p class="title mb-0 py-1">
                          <v-icon left>mdi-filter</v-icon>
                          {{$vuetify.lang.t('$vuetify.courseManagement.courseList.filter')}}
                        </p>
                        <div class="text-right py-1">
                          <v-btn
                            rounded
                            outlined
                            color="primary"
                            dark
                          >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.clearFilter')}}</v-btn>
                        </div>
                      </div>
                      <div class="filter-body my-5">
                        <v-expansion-panels v-model="panel" multiple>
                          <v-expansion-panel class="mb-5">
                            <v-expansion-panel-header>{{$vuetify.lang.t('$vuetify.courseManagement.courseList.progress')}}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <div>
                                <p>{{$vuetify.lang.t('$vuetify.courseManagement.courseList.accomplishment')}}</p>
                                <v-row>
                                  <v-col class="px-4">
                                    <v-range-slider
                                      v-model="range"
                                      :max="max"
                                      :min="min"
                                      hide-details
                                      class="align-center"
                                    >
                                      <template v-slot:prepend>
                                        <v-text-field
                                          :value="range[0]"
                                          class="mt-0 pt-0"
                                          hide-details
                                          single-line
                                          type="number"
                                          style="width: 60px"
                                          @change="$set(range, 0, $event)"
                                        ></v-text-field>
                                      </template>
                                      <template v-slot:append>
                                        <v-text-field
                                          :value="range[1]"
                                          class="mt-0 pt-0"
                                          hide-details
                                          single-line
                                          type="number"
                                          style="width: 60px"
                                          @change="$set(range, 1, $event)"
                                        ></v-text-field>
                                      </template>
                                    </v-range-slider>
                                  </v-col>
                                </v-row>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel class="mb-5">
                            <v-expansion-panel-header>{{$vuetify.lang.t('$vuetify.courseManagement.exam.examination')}}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <div>
                                <p>{{$vuetify.lang.t('$vuetify.courseManagement.exam.chooseExamination')}}</p>
                                <v-checkbox
                                  class="my-0"
                                  v-model="exam_select"
                                  :label="$vuetify.lang.t('$vuetify.courseManagement.exam.examination1')"
                                  value="John"
                                ></v-checkbox>
                                <v-checkbox
                                  class="my-0"
                                  v-model="exam_select"
                                  :label="$vuetify.lang.t('$vuetify.courseManagement.exam.examination2')"
                                  value="Jacob"
                                ></v-checkbox>
                              </div>
                              <v-divider class="my-5"></v-divider>
                              <div>
                                <p>{{$vuetify.lang.t('$vuetify.courseManagement.exam.examinationStatus')}}</p>
                                <v-radio-group v-model="radios" :mandatory="false">
                                  <v-radio
                                    :label="$vuetify.lang.t('$vuetify.courseManagement.exam.all')"
                                    value="ทั้งหมด"
                                  ></v-radio>
                                  <v-radio
                                    :label="$vuetify.lang.t('$vuetify.courseManagement.exam.neverDoExamination')"
                                    value="no"
                                  ></v-radio>
                                  <v-radio
                                    :label="$vuetify.lang.t('$vuetify.courseManagement.exam.haveDoneExamination')"
                                    value="was"
                                  ></v-radio>
                                </v-radio-group>
                              </div>

                              <v-divider class="my-5"></v-divider>
                              <div>
                                <p>{{$vuetify.lang.t('$vuetify.courseManagement.exam.score')}}</p>
                                <v-row>
                                  <v-col class="px-4">
                                    <v-range-slider
                                      v-model="range"
                                      :max="max"
                                      :min="min"
                                      hide-details
                                      class="align-center"
                                    >
                                      <template v-slot:prepend>
                                        <v-text-field
                                          :value="range[0]"
                                          class="mt-0 pt-0"
                                          hide-details
                                          single-line
                                          type="number"
                                          style="width: 60px"
                                          @change="$set(range, 0, $event)"
                                        ></v-text-field>
                                      </template>
                                      <template v-slot:append>
                                        <v-text-field
                                          :value="range[1]"
                                          class="mt-0 pt-0"
                                          hide-details
                                          single-line
                                          type="number"
                                          style="width: 60px"
                                          @change="$set(range, 1, $event)"
                                        ></v-text-field>
                                      </template>
                                    </v-range-slider>
                                  </v-col>
                                </v-row>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                      <div class="text-center">
                        <v-btn rounded color="primary" dark>
                          <v-icon left>mdi-filter</v-icon>
                          {{$vuetify.lang.t('$vuetify.courseManagement.courseList.filter')}}
                        </v-btn>
                      </div>
                    </div>
              </v-col>-->
              <v-toolbar
                flat
                style="background: transparent"
                color="table-header pa-4"
                class="content-right"
              >
                <v-col
                  cols="2"
                  class="ma-md-5 px-0 xs-full-width"
                  v-show="resultAllRoom.length > 1"
                >
                  <span class="caption title-text font-weight-black"
                    >Classroom:</span
                  >
                  <v-select
                    class="text-field-border"
                    :items="roomsCourse"
                    v-model="selectedRoom"
                    outlined
                    background-color="#fff"
                    height="40"
                    @change="onChangeRoom()"
                  ></v-select>
                </v-col>

                <div class="ml-5 xs-full-width mt-10 mb-12">
                  <v-btn
                    height="40px"
                    elevation="0"
                    back
                    outlined
                    @click="refreshStudent"
                    class="mb-7 pl-6 pr-5 xs-full-width body-2 text-field-border mr-2"
                  >
                    <v-icon left>mdi-cached</v-icon>
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.filterBar.refresh'
                      )
                    }}
                  </v-btn>
                  <v-btn
                    height="40px"
                    elevation="0"
                    @click="goToCourseDetail"
                    back
                    outlined
                    class="mb-7 pl-6 pr-5 xs-full-width body-2 text-field-border button-primary white--text"
                  >
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.courseDetail'
                        )
                    }}
                  </v-btn>
                </div>
              </v-toolbar>
              <v-col lg="12" md="12" cols="12">
                <v-row class="pa-5 pt-0 mt-0 pb-0 mb-0">
                  <v-col :lg="5" cols="12" class="pt-0">
                    <v-row>
                      <v-col :lg="6" :md="6" :sm="12" cols="12" class="pt-0">
                        <div class="stat-num stat-num-top px-1">
                          <v-col class="d-flex py-0">
                            <v-icon class="mr-1 white--text" large
                              >check_circle</v-icon
                            >
                            <v-col>
                              <v-col class="pa-0">COMPLETED</v-col>
                              <v-col class="pa-0">(สำเร็จ)</v-col>
                            </v-col>
                          </v-col>
                          <v-row
                            class="d-flex align-end mx-1 font-weight-light"
                          >
                            <v-col class="text-end pt-0">
                              <span class="display-1 font-weight-light">{{
                                completedUser
                              }}</span>
                              <br />users
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                      <v-col :lg="6" :md="6" :sm="12" cols="12" class="pt-0">
                        <div class="stat-num stat-num-not-completed px-1">
                          <v-col class="d-flex py-0">
                            <v-icon class="mr-1 white--text" large
                              >warning</v-icon
                            >
                            <v-col>
                              <v-col class="pa-0">NOT COMPLETED</v-col>
                              <v-col class="pa-0">(ยังไม่สำเร็จ)</v-col>
                            </v-col>
                          </v-col>
                          <v-row
                            class="d-flex align-end mx-1 font-weight-light"
                          >
                            <v-col class="text-end pt-0">
                              <span class="display-1 font-weight-light">{{
                                notCompletedUser
                              }}</span>
                              <br />users
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="align-center">
                      <v-col :lg="12" :md="12" :sm="12" cols="12" class="pa-3">
                        <apexchart
                          type="radialBar"
                          height="400"
                          :options="chartOptionsAngleCircle"
                          :series="seriesAngleCircle"
                        ></apexchart>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :lg="7" cols="12" class="pt-0">
                    <v-row>
                      <v-col
                        :lg="4"
                        :md="4"
                        :sm="12"
                        cols="12"
                        class="pa-3 pt-0"
                      >
                        <div class="stat-num stat-num-total px-1">
                          <v-col class="d-flex py-0">
                            <v-icon class="mr-1 white--text" large
                              >assignment_ind</v-icon
                            >
                            <v-col>
                              <v-col class="pa-0">TOTAL</v-col>
                              <v-col class="pa-0">(เรียนทั้งหมด)</v-col>
                            </v-col>
                          </v-col>
                          <v-row
                            class="d-flex align-end mx-1 font-weight-light"
                          >
                            <v-col class="text-end pt-0">
                              <span class="display-1 font-weight-light">{{
                                totalUser
                              }}</span>
                              <br />users
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                      <v-col
                        :lg="4"
                        :md="4"
                        :sm="12"
                        cols="12"
                        class="pa-3 pt-0"
                      >
                        <div class="stat-num stat-num-today px-1">
                          <v-col class="d-flex py-0">
                            <v-icon class="mr-1 white--text" large
                              >today</v-icon
                            >
                            <v-col>
                              <v-col class="pa-0">TODAY</v-col>
                              <v-col class="pa-0">(เข้าเรียนวันนี้)</v-col>
                            </v-col>
                          </v-col>
                          <v-row
                            class="d-flex align-end mx-1 font-weight-light"
                          >
                            <v-col class="text-end pt-0">
                              <span class="display-1 font-weight-light">{{
                                userToday
                              }}</span>
                              <br />users
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                      <v-col
                        :lg="4"
                        :md="4"
                        :sm="12"
                        cols="12"
                        class="pa-3 pt-0"
                      >
                        <div class="stat-num stat-num-online px-1">
                          <v-col class="d-flex py-0">
                            <v-icon class="mr-1 white--text" large
                              >toggle_on</v-icon
                            >
                            <v-col>
                              <v-col class="pa-0">ONLINE</v-col>
                              <v-col class="pa-0">(กำลังเรียน)</v-col>
                            </v-col>
                          </v-col>
                          <v-row
                            class="d-flex align-end mx-1 font-weight-light"
                          >
                            <v-col class="text-end pt-0">
                              <span class="display-1 font-weight-light">{{
                                onlineUser
                              }}</span>
                              <br />users
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="align-center justify-center">
                      <v-col :lg="12" :md="12" :sm="12" cols="12" class="pa-3">
                        <div class="graph-card pa-5 pt-3">
                          <v-col>
                            <v-col
                              class="pr-2 d-flex justify-between align-end"
                            >
                              <span class="headline font-weight-light"
                                >Learner</span
                              >
                            </v-col>
                            <apexchart
                              type="area"
                              height="320"
                              :options="overallChartOptions"
                              :series="overallSeries"
                            ></apexchart>
                          </v-col>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row justify="center">
                  <v-dialog v-model="alert" persistent max-width="450">
                    <v-card>
                      <v-card-title class="headline">{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.courseList.sorry'
                        )
                      }}</v-card-title>
                      <v-card-text>
                        <div
                          v-html="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.courseList.alertPermissionFunction'
                            )
                          "
                        ></div>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary darken-1"
                          text
                          @click="alert = false"
                          >{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.courseList.ok'
                            )
                          }}</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-row>
    </v-form>
    <div>
      <v-snackbar v-model="snackbar" :timeout="timeout">
        {{ error }}
        <v-btn color="blue" text @click="snackbar = false">{{
          $vuetify.lang.t('$vuetify.courseManagement.accessStep.close')
        }}</v-btn>
      </v-snackbar>
      <v-snackbar v-model="snackbar2" :timeout="timeout">
        {{ success }}
        <v-btn color="green" text @click="snackbar = false">{{
          $vuetify.lang.t('$vuetify.courseManagement.accessStep.close')
        }}</v-btn>
      </v-snackbar>
    </div>
  </v-table>

  <!-- </v-card> -->
</template>

<script>
import { removeUserInCourse } from '@/service/mylib/list';
// import { loadCategory } from "@/service/category/category";
// import { loadSkill, insertSkill } from "@/service/skill/skill";
import {
  getCourseById,
  getReportStudentHistory,
} from '@/service/course/course';
import {
  // getUserGroup,
  getlistCompany,
  getUserGroupCompany,
  getDetailCompany,
  setUserGroupToCourseByAdmin,
  setDetailCompany,
  setUserGroupToCourse,
} from '@/service/account/manageUserGroup';
import { getRoom } from '@/service/room/room';
import { getOverviewReportCourse } from '@/service/course/report';
import VueApexCharts from 'vue-apexcharts';

export default {
  components: {
    // sectionRoom,

    apexchart: VueApexCharts,
  },
  data() {
    return {
      // learningOrder: true,
      // haveDashboard: false,
      // haveInbox: false,
      valid: true,
      validSearch: true,
      //edit
      isEdit: false,
      courseID: '',
      userGroupSelect: [],
      userGroup: [],

      snackbar: false,
      snackbar2: false,
      error: 'Invalid Data! Please complete all information of the course!',
      success: 'Success, creating course!',
      timeout: 5000,
      detail: {},

      listCompany: [],
      listFilterCompany: [],
      listDetailCompany: [],
      listDetailTemp: [],
      selectedCompany: '',
      userGroupByAdmin: [],
      userGroupSelectByAdmin: [],
      companySelectByAdmin: '',
      indexSelectByAdmin: 0,
      companyModal: false,
      allGroup: [],
      searchCompany: '',

      //search
      searchByUserDialog: false,
      searchByAdminDialog: false,
      userGroupSearch: [],
      userGroupAllAtIndex: [],
      indexSelectIdForSearch: 0,
      groupRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.userGroupRequired'
          ),
        // v => (v && v.length >= 2) || "Category must be at least 2 characters"
      ],
      select: false,

      // modal Company
      headers: [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.organizationLogo'
          ),
          align: 'start',
          sortable: false,
          value: 'logo',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.organizationName'
          ),
          value: 'title',
          sortable: false,
        },
        // { text: "Actions", value: "actions", sortable: false }
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.add'
          ),
          value: 'actions',
          sortable: false,
        },
      ],
      searchdata: '',
      pageCount: 1,
      limit: 10,
      params: {},
      selectNewCompany: [],

      // Report
      imageCourse: '',
      title: '',
      courseId: '',
      instructorName: '',
      roomId: '',
      roomsCourse: [],
      section_data: [],
      resultAllRoom: [],
      selectedRoom: '',
      searchdataStudent: '',
      reportStudentList: [],
      status_student_toggle: 0,

      dialogFullReport: true,
      dialogViewReport: false,
      dialogExamReport: false,
      dialogFormUser: false,
      dialogStatus: false,
      dialogStatusActive: false,
      dialogSuccess: false,
      dialogDelete: false,

      image: null,
      searchCourseReport: null,
      searchStudentReport: null,
      studentId: '',
      fullName: '',
      room: '',
      firstName: '',
      lastName: '',
      email: '',
      username: '',
      tel: '',
      birthdate: '',
      gender: '',
      historyList: [],
      historyExamList: [],
      students: [],
      chooseRoom: false,
      objCourse: [],
      knowledge: 0,
      status_toggle: 0,
      countStartedStudents: [],
      countNotStartedStudents: [],
      examTitle: '',
      fullScore: 0,
      numOfQuestions: 0,
      studentReportExams: [],
      dialogEditScoreExam: false,
      arrQuestion: [],
      bool: false,

      correct_dialog: false,
      correct_matchsome: [],
      question_type: {
        single: 'ตัวเลือกเดียว',
        fillgaptext: 'เติมคำ',
        matchsome: 'จับคู่',
        multiple: 'หลายตัวเลือก',
      },

      alert: false,
      chooseSection: false,
      filterdialog: false,
      deleteDialog: false,

      userDialog: false,
      confirmDialog: false,
      registerTutoralert: false,

      loading: true,
      searchby: this.$vuetify.lang.t('$vuetify.courseManagement.courseName'),
      searchType: [
        this.$vuetify.lang.t('$vuetify.courseManagement.courseName'),
        this.$vuetify.lang.t('$vuetify.courseManagement.teacherName'),
      ],
      // sortType: [
      //     this.$vuetify.lang.t(
      //         "$vuetify.courseManagement.filterBar.highToLowTime"
      //     ),
      //     this.$vuetify.lang.t(
      //         "$vuetify.courseManagement.filterBar.lowToHightTime"
      //     ),
      //     this.$vuetify.lang.t(
      //         "$vuetify.courseManagement.filterBar.hightToLowRating"
      //     ),
      //     this.$vuetify.lang.t(
      //         "$vuetify.courseManagement.filterBar.lowToHightRating"
      //     ),
      // ],

      // series: [
      //   {
      //     name: "ข้อที่ถูก",
      //     data: [44, 55, 57, 56, 61,],
      //   },
      //   {
      //     name: "ข้อที่ถูก",
      //     data: [44, 55, 57, 56, 61,],
      //   },
      //   {
      //     name: "คะแนนของคุณ",
      //     data: [76, 85, 100, 98, 87]
      //   }
      // ],
      // chartOptions: {
      //   chart: {
      //     type: "bar"
      //   },
      //   plotOptions: {
      //     bar: {
      //       horizontal: false,
      //       columnWidth: "50%"
      //     }
      //   },
      //   dataLabels: {
      //     enabled: false
      //   },
      //   stroke: {
      //     show: true,
      //     width: 2,
      //     colors: ["transparent"]
      //   },
      //   grid: {
      //     row: {
      //       colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
      //       opacity: 0.5
      //     }
      //   },
      //   xaxis: {
      //     categories: [
      //       "ครั้งที่ 1",
      //       "ครั้งที่ 2",
      //       "ครั้งที่ 3",
      //       "ครั้งที่ 4",
      //       "ครั้งที่ 5"
      //     ]
      //   },
      //   // yaxis: {
      //   //   subtitle: {
      //   //     text: "คะแนน"
      //   //   }
      //   // },
      //   fill: {
      //     opacity: 1
      //   },
      //   tooltip: {
      //     y: {
      //       formatter: function(val) {
      //         return val + " คะแนน";
      //       }
      //     }
      //   }
      // },

      fileExcelName: 'รายงานสรุปผลการสอบ.xls',
      dataForExcel: [],
      // dataForExcel: [
      //   { รายการสอบ: "Another", },
      //   { รายการสอบ: "Another", ครั้งที่1: "Regular cell" },
      //   { รายการสอบ: "Hello", ครั้งที่1: "World", ครั้งที่2: "World" },
      // ],

      // {
      //     text: this.$vuetify.lang.t(
      //       "$vuetify.courseManagement.courseList.studentManagement"
      //     ),
      //     align: "center",
      //     sortable: false,
      //     value: "actions"
      //   },
      //   {
      //     text: this.$vuetify.lang.t(
      //       "$vuetify.courseManagement.courseList.report"
      //     ),
      //     align: "center",
      //     sortable: false,
      //     value: "report"
      //   },
      headerStudentExam: [
        {
          text: 'No',
          align: 'center',
          sortable: false,
          value: 'num',
          width: '5%',
        },
        {
          text: 'Exam Date',
          align: 'center',
          sortable: false,
          value: 'examDate',
          width: '50%',
        },
        {
          text: 'Score',
          align: 'center',
          sortable: false,
          value: 'score',
          width: '15%',
        },
        {
          text: 'Correct',
          align: 'center',
          sortable: false,
          value: 'correct',
          width: '10%',
        },
        {
          text: 'Wrong',
          align: 'center',
          sortable: false,
          value: 'wrong',
          width: '10%',
        },
        {
          text: 'No Answer',
          align: 'center',
          sortable: false,
          value: 'noAnswer',
          width: '10%',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'action',
          width: '10%',
        },
      ],
      headerStudents: [
        {
          text: this.$vuetify.lang.t('$vuetify.profilePic'),
          align: 'center',
          sortable: false,
          value: 'image',
          width: '15%',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.fullName'),
          value: 'fullName',
          align: 'start',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t('$vuetify.progress'),
          value: 'progress',
          align: 'start',
          sortable: false,
          width: '40%',
        },
        // {
        //   text: this.$vuetify.lang.t("$vuetify.email"),
        //   value: "email",
        //   align: "center",
        //   sortable: false
        // },
        // {
        //   text: this.$vuetify.lang.t("$vuetify.username"),
        //   value: "userName",
        //   align: "center",
        //   sortable: false
        // },
        // {
        //   text: this.$vuetify.lang.t("$vuetify.room"),
        //   value: "room",
        //   align: "center",
        //   sortable: false
        // },
        {
          text: '',
          value: 'report',
          align: 'center',
          sortable: false,
          width: '5%',
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '5%',
        },
        // {
        //   text: this.$vuetify.lang.t("$vuetify.studentInformation"),
        //   value: "actions",
        //   align: "center",
        //   sortable: false
        // }
      ],
      headersMockup: [
        {
          text: 'วันที่',
          align: 'center',
          sortable: false,
          value: 'date',
        },
        {
          text: 'เวลาที่ใช้งาน',
          align: 'center',
          value: 'timeLearn',
          sortable: false,
        },
        {
          text: 'กิจกรรม',
          align: 'center',
          value: 'activity',
          sortable: false,
        },
      ],
      historyItems: [
        {
          date: '4 เมษายน 2563',
          timeLearn: '03:00:00 ชม.',
          activity: 'ดาราศาสตร์',
        },
        {
          date: '10 เมษายน 2563',
          timeLearn: '03:00:00',
          activity: 'วิทยาศาสตร์ ชม.',
        },
      ],
      courses: [],
      sortData: 'เวลา สูง-ต่ำ',
      searchCourse: null,
      searchStudent: null,
      category: [],
      skill: [],
      selectedSkill: [],
      selectedCategory: null,
      active: null,
      deleteItemID: [],

      //user
      manageUserCourseID: '',

      //select dialog
      selectSectionDialog: false,
      section_headers: [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.dialogChooseStudyingGroup.groupName'
          ),
          align: 'start',
          sortable: false,
          value: 'title',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.dialogChooseStudyingGroup.lecturerName'
          ),
          value: 'teacher',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.dialogChooseStudyingGroup.numberStudents'
          ),
          value: 'countStudent',
          sortable: false,
          align: 'center',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.dialogChooseStudyingGroup.chooseGroup'
          ),
          sortable: false,
          align: 'center',
          value: 'select',
        },
      ],
      // id: room._id,
      //teacher: room.teacher,
      //title: room.title,
      //countStudent: room.countStudent,
      //isPublic: room.isPublic,
      //permissionedit: room.permissionedit
      roomID: '',
      learnerRequest: 0,
      isTeacher: '',
      reject_note: '',
      rooms: [],
      dialogCantPublic: false,
      messageCantPublic: '',

      // paginaton report student
      page_student: 1,
      limit_student: 50,
      pageCount_student: 1,
      tempScore: null,

      page_editScore: 1,
      limit_editScore: 50,
      pageCount_editScore: 1,

      // filter student panel
      panel: [0, 1],
      exam_select: ['John'],
      range: [0, 70],
      min: 0,
      max: 100,

      completedUser: 0,
      notCompletedUser: 0,
      totalUser: 0,
      userToday: 0,
      onlineUser: 0,
      totalPercent: 0,
      sumPercentProgress: 0,
      differencePercent: 0,

      // more item
      more_item: [{}],
      // series: [],
      // chartOptions: {
      //   series: this.series,
      //   chart: {
      //     width: 100,
      //     type: "donut",
      //   },
      //   dataLabels: {
      //     enabled: true,
      //   },
      //   title: {
      //     display: true,
      //     text: "Learning Progress",
      //   },
      //   labels: ["Completed", "Not Completed"],
      //   fill: {
      //     type: "gradient",
      //     colors: ["#0779e4", "#699ab2"],
      //   },
      //   colors: ["#0779e4", "#699ab2"],
      //   legend: {
      //     formatter: function (val, opts) {
      //       return (
      //         val +
      //         " " +
      //         opts.w.globals.series[opts.seriesIndex].toFixed(2) +
      //         "%"
      //       );
      //     },
      //     markers: {
      //       fillColors: ["#0779e4", "#699ab2"],
      //     },
      //     offsetY: 0,
      //     height: 50,
      //   },
      //   responsive: [
      //     {
      //       breakpoint: 480,
      //       options: {
      //         chart: {
      //           width: 200,
      //         },
      //         legend: {
      //           position: "bottom",
      //         },
      //       },
      //     },
      //   ],
      // },
      // seriesLearningProgress: [],
      // chartOptionsLearningProgress: {
      //   series: this.seriesLearningProgress,
      //   chart: {
      //     width: 100,
      //     type: "donut",
      //   },
      //   dataLabels: {
      //     enabled: true,
      //   },
      //   title: {
      //     display: true,
      //     text: "About Learners",
      //   },
      //   labels: ["Completed", "Not Completed"],
      //   fill: {
      //     type: "gradient",
      //     colors: ["#0779e4", "#ec0101"],
      //   },
      //   colors: ["#0779e4", "#ec0101"],
      //   legend: {
      //     formatter: function (val, opts) {
      //       return val + " " + opts.w.globals.series[opts.seriesIndex];
      //     },
      //     markers: {
      //       fillColors: ["#0779e4", "#ec0101"],
      //     },
      //     offsetY: 0,
      //     height: 50,
      //   },
      //   responsive: [
      //     {
      //       breakpoint: 480,
      //       options: {
      //         chart: {
      //           width: 200,
      //         },
      //         legend: {
      //           position: "bottom",
      //         },
      //       },
      //     },
      //   ],
      // },
      remove_item: '',
      reject_item: '',
      seriesAngleCircle: [],
      chartOptionsAngleCircle: {
        chart: {
          height: 400,
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 0,
              size: '70%',
              background: '#293450',
              image: undefined,
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24,
              },
            },
            track: {
              background: '#d6e0f0',
              // dropShadow: {
              //   enabled: true,
              //   top: 2,
              //   left: 0,
              //   blur: 4,
              //   opacity: 0.15,
              // },
            },
            dataLabels: {
              name: {
                offsetY: -10,
                color: '#fff',
                fontSize: '20px',
              },
              value: {
                color: '#fff',
                fontSize: '30px',
                show: true,
              },
              total: {
                show: true,
                color: '#fff',
                label: 'Completed Learner',
                formatter: function (w) {
                  if (w.globals.series[0] > 0) {
                    return w.globals.series[0] + '%';
                  } else {
                    return '00.00%';
                  }
                },
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'vertical',
            gradientToColors: ['#87D4F9', '#87D4F9'],
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        colors: ['#0779e4', '#81b214'],
        labels: ['Completed Learner', 'Learning Progress'],
        legend: {
          show: false,
          labels: {
            useSeriesColors: true,
          },
          markers: {
            size: 0,
          },
          formatter: function (seriesName, opts) {
            return (
              seriesName + ':  ' + opts.w.globals.series[opts.seriesIndex] + '%'
            );
          },
          itemMargin: {
            vertical: 3,
          },
        },
        // responsive: [
        //   {
        //     breakpoint: 480,
        //     options: {
        //       legend: {
        //         show: false,
        //       },
        //     },
        //   },
        // ],
      },

      overallSeries: [
        {
          name: 'Num of Learner',
          data: [],
        },
      ],
      overallChartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 350,

          zoom: {
            type: 'x',
            enabled: false,
            autoScaleYaxis: true,
          },
          toolbar: {
            tools: {
              download: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
        },
        title: {
          text: '',
          align: 'left',
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0.5,
            stops: [0, 90, 100],
          },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              if (Number.isInteger(val)) {
                return val;
              }
            },
          },
          title: {
            text: 'Num of Students',
          },
        },
        xaxis: {
          type: 'datetime',
          tickAmount: 30,
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy',
          },
          colors: ['#669966'],
        },
      },
    };
  },
  computed: {},
  watch: {
    searchdata(keyword) {
      this.searchInfo(keyword);
    },
    searchdataStudent(keyword) {
      this.searchInfoStudent(keyword);
    },
    series(value) {
      console.log('value', value);
    },
    // seriesAngleCircle(value) {
    //   console.log('value', value);
    // },
    // $vuetify(oldVal,newVal){
    //   oldVal.lang.current
    // }
  },
  methods: {
    async initialize() {
      console.log(this.$store.state.permission.superAdmin);
      this.courseID = this.$route.query.id;
      if (this.courseID != null) {
        let params = {
          id: this.courseID,
        };

        await this.getCourseDetail(params);
        this.isEdit = true;
      }

      let resultCompany = await getDetailCompany({
        idcourse: this.courseID,
      });
      console.log('resultCompany', resultCompany);

      this.listDetailCompany = resultCompany;
      if (this.$store.state.permission.superAdmin === false) {
        this.listCompany = await getUserGroupCompany();
      } else {
        this.listCompany = await getlistCompany();
      }
      console.log(' this.listCompany.data', this.listCompany.data);
      this.listFilterCompany = await this.listCompany.data.map(
        (company) => company.companies
      );

      console.log('tempCompanyId', this.listDetailCompan);
      let tempCompanyId = this.listDetailCompany.map(
        (company) => company.companies._id
      );
      // console.log('tempCompanyId',tempCompanyId)
      this.listFilterCompany = this.listFilterCompany.filter(
        (isSelectCom) =>
          tempCompanyId.findIndex(
            (companyId) => companyId === isSelectCom._id
          ) === -1
      );

      console.log('listFilterCompany', this.listDetailCompany);

      this.listDetailTemp = [];
      for (let i = 0; i < this.listDetailCompany.length; i++) {
        console.log(this.listDetailCompany[i].user_groups);
        let userGroup = await this.listDetailCompany[i].user_groups.map(
          (groups) => groups._id
        );
        await this.listDetailTemp.push({
          user_groups: userGroup,
        });
      }
      console.log(
        'listDetailTemp',
        this.listDetailTemp[this.indexSelectByAdmin].user_groups
      );
      this.userGroupSelectByAdmin = this.listDetailTemp[
        this.indexSelectByAdmin
      ].user_groups;

      let myCompanyIndex = await this.listDetailCompany.findIndex(
        (company) => company.companies._id === this.$store.state.company._id
      );

      let indexGroupByOwn = await this.listCompany.data.findIndex(
        (company) => company.companies._id === this.$store.state.company._id
      );
      console.log('this.listCompany.data', indexGroupByOwn);
      this.userGroup =
        indexGroupByOwn !== -1
          ? await this.listCompany.data[indexGroupByOwn].user_groups
          : '';
      this.userGroup =
        indexGroupByOwn !== -1
          ? await this.userGroup.filter((group) => group.active !== false)
          : [];

      this.userGroup =
        this.userGroup.length > 0 ? await this.addAllGroup(this.userGroup) : [];
      this.userGroupSelect = this.listDetailTemp[myCompanyIndex]
        ? this.listDetailTemp[myCompanyIndex].user_groups
        : [];

      this.userGroupAllAtIndex = [];
      await this.listCompany.data.forEach(async (company) => {
        let arrayGroup = [];
        company.user_groups.forEach(async (group) => {
          group.child_User_Group.length === 0
            ? await arrayGroup.push({
                title: group.title,
                _id: group._id,
              })
            : null;
          group.child_User_Group.forEach(async (child) => {
            child.child_User_Group.length === 0
              ? await arrayGroup.push({
                  title: group.title + ' -> ' + child.title,
                  _id: child._id,
                })
              : null;
            child.child_User_Group.forEach(async (lastChild) => {
              await arrayGroup.push({
                title:
                  group.title + ' -> ' + child.title + ' -> ' + lastChild.title,
                _id: lastChild._id,
              });
            });
          });
        });
        await this.userGroupAllAtIndex.push({
          user_groups: arrayGroup,
        });
      });
      this.indexSelectByAdmin = myCompanyIndex ? myCompanyIndex : 0;
      this.indexSelectIdForSearch = indexGroupByOwn ? indexGroupByOwn : 0;

      this.openDialogGetReport(this.detail);

      // let requestArr = this.$store.state.requestData;
      // requestArr.forEach((request) => {
      //   if (request._id == this.courseID) {
      //     this.learnerRequest = request.totalLearner
      //   }
      // });
    },
    removeByUser(item) {
      const index = this.userGroupSelect.indexOf(item._id);
      if (index >= 0) this.userGroupSelect.splice(index, 1);
    },
    removeByAdmin(item) {
      const index = this.userGroupSelectByAdmin.indexOf(item._id);
      if (index >= 0) this.userGroupSelectByAdmin.splice(index, 1);
    },
    async getCourseDetail(params) {
      let detail = await getCourseById(params);
      this.detail = detail;
      console.log('detail course', this.detail);
      // this.userGroupSelect = detail.user_groups;
      // this.userGroupSelect = detail.user_groups;
      // this.learningOrder = detail.learningOrder;
      // this.haveDashboard = detail.haveDashboard;
      // this.haveInbox = detail.haveInbox;
    },
    addAllGroup(group) {
      return [
        {
          levelSub: 1,
          child_User_Group: group,
          _id: 'all',
          title: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.all'
          ),
        },
      ];
    },
    goList() {
      this.$router.push({
        path: '/course',
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    showCheckBox() {
      console.log(this.selectNewCompany);
    },
    async accessSubmit() {
      // let status = await updateCourse({
      //   ...this.detail,
      //   id: this.detail._id,
      //   learningOrder: this.learningOrder,
      //   haveInbox: this.haveInbox,
      //   haveDashboard: this.haveDashboard
      // });
      //get old user_group
      let groupCompany = [];
      await this.listDetailTemp.forEach((company, index) => {
        index !== this.indexSelectByAdmin
          ? groupCompany.push(...company.user_groups)
          : '';
      });
      console.log(groupCompany);
      // user
      if (this.$store.state.permission.superAdmin === false) {
        console.log('user');
        let result = await setUserGroupToCourse({
          idcourse: this.courseID,
          usergroup: this.userGroupSelect,
        });
        console.log(result);
      }
      // admin
      else if (this.$store.state.permission.superAdmin === true) {
        let result = await setUserGroupToCourseByAdmin({
          idcourse: this.courseID,
          usergroup: [...groupCompany, ...this.userGroupSelectByAdmin],
        });
        console.log(result);
      }

      await this.goList();
      // await this.initialize();
      // console.log(status);
    },
    async selectCompany(id, index) {
      this.select = true;

      let indexSelectId = await this.listCompany.data.findIndex(
        (company) => company.companies._id === id
      );
      this.userGroupByAdmin = this.listCompany.data[indexSelectId].user_groups;

      this.userGroupByAdmin = await this.userGroupByAdmin.filter(
        (group) => group.active !== false
      );

      this.userGroupByAdmin =
        this.userGroupByAdmin.length > 0
          ? await this.addAllGroup(this.userGroupByAdmin)
          : [];
      this.indexSelectByAdmin = index;
      this.indexSelectIdForSearch = indexSelectId;
      this.userGroupSelectByAdmin = this.listDetailTemp[index].user_groups;
    },
    openDialog() {
      this.companyModal = true;
    },
    openDialogSearchByUser() {
      this.searchByUserDialog = true;
    },
    openDialogSearchByAdmin() {
      this.searchByAdminDialog = true;
    },
    closesearchByUserDialog() {
      this.userGroupSearch = [];
      this.searchByUserDialog = false;
    },
    closesearchByAdminDialog() {
      this.userGroupSelectByAdmin = [];
      this.searchByAdminDialog = false;
    },
    async closeDialog() {
      this.companyModal = false;
      this.selectNewCompany = [];
    },
    async closeGroupSearchDialog() {
      this.companyModal = false;
      this.selectNewCompany = [];
    },
    refreshStudent() {
      this.initialize();
      this.searchdataStudent = '';
      this.selectedRoom = '';
      this.status_student_toggle = 0;
      // this.openDialogGetReport(this.section_data);
    },
    async viewProgressReport(item) {
      console.log(item);
      this.dialogViewReport = true;
      this.image = item.image;
      this.fullName = item.fullName;
      this.userName = item.userName;
      this.email = item.email;
      this.tel = item.tel == '' || item.tel == null ? '-' : item.tel;
      this.birthdate =
        item.birthdate == '' || item.birthdate == null
          ? '-'
          : new Date(item.birthdate).toLocaleDateString();
      this.gender =
        item.gender == '' || item.gender == null ? '-' : item.gender;

      this.courseId = this.$route.query.id;
      this.studentId = item.id;
      this.getReportHistory();
    },
    openRejectDialog(item) {
      console.log('item openRejectDialog', item);
      this.checkAccept = item.acceptMylib;
      this.remove_item = item.idMylib;
      this.dialogDelete = true;
    },
    async rejectUser() {
      if (this.checkAccept == true) {
        let data = {
          id: this.remove_item,
        };
        let result = await removeUserInCourse(data);
        if (result) {
          // let resultTotalRequest = await getTotalRequest();
          // store.commit("setTotal", resultTotalRequest.course);
          this.dialogDelete = false;
          this.checkAccept = null;
          // await this.getStudentCourseList();
        }
      } else {
        console.log('check Accept is false');
      }
    },
    async getReportHistory() {
      let result = await getReportStudentHistory({
        idcourse: this.$route.query.id,
        idstudent: this.studentId,
      });
      console.log('history : ', result);
      this.historyList = result;
      this.historyExamList = [];
      this.dataForExcel = [];
      this.knowledge = this.historyList.avgPercentAll;
      this.hisAvg = this.historyExamList.hisAvg;
      result.lectureExam.forEach((history) => {
        this.historyExamList.push({
          hisExamTitle: history.lecture.exams[0].title,
          hisExamType: history.type,
          hisAvg: history.avgScore,
          hisScore: history.getAllScore.map((term) => term.score),
          hisWrong: history.getAllScore.map((term) => term.wrong),
          hisCorrect: history.getAllScore.map((term) => term.correct),
          series: [
            {
              name: 'คะแนนของคุณ',
              data: history.getAllScore.map((term) => term.score),
            },
          ],
          chartOptions: {
            // chart: {
            //   type: "bar"
            // },
            // plotOptions: {
            //   bar: {
            //     horizontal: false,
            //     columnWidth: "50%"
            //   }
            // },
            // dataLabels: {
            //   enabled: false
            // },
            // stroke: {
            //   show: true,
            //   width: 2,
            //   colors: ["transparent"]
            // },
            // grid: {
            //   row: {
            //     colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            //     opacity: 0.5
            //   }
            // },
            // xaxis: {
            //   categories: history.getAllScore.map((term, index) => index + 1)
            // },
            // // yaxis: {
            // //   subtitle: {
            // //     text: "คะแนน"
            // //   }
            // // },
            // fill: {
            //   opacity: 1
            // },
            // tooltip: {
            //   y: {
            //     formatter: function(val) {
            //       return val + " คะแนน";
            //     }
            //   }
            // }
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'straight',
            },
            grid: {
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5,
              },
            },
          },
        });
      });
      console.log('log exam list : ', this.historyExamList);
      this.historyExamList.sort(function (a, b) {
        return b.hisScore.length - a.hisScore.length;
      });
      this.historyExamList.forEach((exam) => {
        // console.log("คะแนนเฉลี่ย :", exam.hisAvg);
        let data = {
          รายการข้อสอบ: exam.hisExamTitle,
        };
        exam.hisScore.forEach((score, index) => {
          data[`ครั้งที่ ${index + 1}`] = score;
        });
        data[`คะแนนเฉลี่ย`] = exam.hisAvg;

        this.dataForExcel.push(data);
      });
      console.log(this.dataForExcel);
    },

    searchInfo() {
      // this.params.search = this.searchdata;
      // this.getCourseList();
    },
    async insertNewCompany() {
      let result = await setDetailCompany({
        idcourse: this.courseID,
        companies: [
          ...(await this.listDetailCompany.map(
            (companies) => companies.companies._id
          )),
          ...this.selectNewCompany,
        ],
      });
      console.log(result);
      await this.closeDialog();
      await this.initialize();
    },
    async deleteCompany(id) {
      let filterOutCompany = await this.listDetailCompany.filter(
        (companies) => companies.companies._id !== id
      );
      let findDeleteIndex = await this.listDetailCompany.findIndex(
        (companies) => companies.companies._id === id
      );
      let result = await setDetailCompany({
        idcourse: this.courseID,
        companies: [
          ...(await filterOutCompany.map(
            (companies) => companies.companies._id
          )),
        ],
      });

      let groupCompany = [];
      await this.listDetailTemp.forEach((company, index) => {
        index !== findDeleteIndex
          ? groupCompany.push(...company.user_groups)
          : '';
      });
      console.log(groupCompany);

      let resultSetGroup = await setUserGroupToCourseByAdmin({
        idcourse: this.courseID,
        usergroup: [...groupCompany],
      });

      console.log(result);
      console.log(resultSetGroup);
      await this.initialize();
    },
    applyStudentFilter() {
      // this.getStudentCourseList();
    },
    async openDialogGetReport(objCourse) {
      let resultRoom = await getRoom({
        idcourse: this.$route.query.id,
      });

      resultRoom.forEach((room) => {
        this.section_data.push({
          id: room._id,
          teacher: room.teacher,
          title: room.title,
          countStudent: room.countStudent,
        });
      });
      this.resultAllRoom = resultRoom;
      this.section_data.map((section) => {
        this.roomsCourse.push(section.title);
      });

      this.imageCourse = objCourse.image;
      this.title = objCourse.title;
      this.courseId = this.$route.query.id;
      this.selectedRoom = this.roomsCourse[0];
      // this.roomTitle = item[0].title;
      this.instructorName = objCourse.owner_by_students[0]._id.displayName;
      this.roomId = this.section_data[0].id;
      console.log('lfpelfplep', this.roomId);
      this.getOverviewReport();
      // this.getStudentCourseList();

      let requestArr = this.$store.state.requestData;
      requestArr.forEach((request) => {
        if (request._id == this.courseID) {
          request.room.forEach((room) => {
            if (room._id == this.section_data[0].id) {
              this.learnerRequest = request.totalLearner;
            }
          });
        }
      });
    },
    async changePageStudent(page) {
      this.page_student = page;
      // await this.getStudentCourseList();
    },
    async changePageEditScore() {
      console.log(this.arrQuestion);
      this.arrTempScore = [];
      this.arrQuestion.forEach((arrq) => {
        this.arrTempScore.push({
          score: arrq.studentScore,
        });
      });
      console.log(this.arrTempScore);
      await this.getQuestionListExam();
    },
    closeDialogFullReport() {
      this.dialogFullReport = false;

      // Clear Dialog Full Report Data
      this.imageCourse = '';
      this.title = '';
      this.courseId = '';
      this.instructorName = '';
      this.roomId = '';
      this.roomsCourse = [];
      this.section_data = [];
      this.selectedRoom = '';
      this.searchdataStudent = '';
      this.reportStudentList = [];
      this.status_student_toggle = 0;
    },
    closeDialogViewReport() {
      // Clear Dialog View Report Data
      this.dialogViewReport = false;

      this.fullName = '';
      this.userName = '';
      this.email = '';
      this.tel = '';
      this.birthdate = '';
      this.gender = '';

      this.historyList = [];
    },
    closeDialogExamReport() {
      this.dialogExamReport = false;
      this.examTitle = '';
      this.fullScore = '';
      this.numOfQuestions = '';
      this.studentReportExams = [];
    },
    async CloseUserModal() {
      this.userDialog = false;
      this.learnerRequest = 0;
      let requestArr = this.$store.state.requestData;
      let index = this.roomsCourse.indexOf(this.selectedRoom);
      requestArr.forEach((request) => {
        if (request._id == this.courseID) {
          request.room.forEach((room) => {
            if (room._id == this.section_data[index].id) {
              this.learnerRequest = request.totalLearner;
            }
          });
        }
      });
      // await this.getStudentCourseList();
    },
    closeDialogReject() {
      this.dialogDelete = false;
      this.checkAccept = null;
      this.remove_item = '';
    },
    async closedialogEditScoreExam() {
      this.dialogEditScoreExam = false;
      this.arrQuestion = [];
      this.bool = false;
      await this.getReportStudentExamScore(this.primaryExamId);
    },
    searchInfoStudent(keyword) {
      this.params.search = keyword;
      // this.getStudentCourseList();
    },
    async onChangeRoom() {
      let index = this.roomsCourse.indexOf(this.selectedRoom);
      // this.roomTitle = this.section_data[index].title;
      this.instructorName = this.section_data[index].teacher.displayName;
      this.roomId = this.section_data[index].id;
      this.courseId = this.$route.query.id;
      // console.log("Selected Room:", this.section_data[index]);
      await this.getOverviewReport();
      // await this.getStudentCourseList();

      this.learnerRequest = 0;
      let requestArr = this.$store.state.requestData;
      requestArr.forEach((request) => {
        if (request._id == this.courseID) {
          request.room.forEach((room) => {
            if (room._id == this.section_data[index].id) {
              this.learnerRequest = request.totalLearner;
            }
          });
        }
      });
    },
    async getOverviewReport() {
      let result = await getOverviewReportCourse({
        idcourse: this.$route.query.id,
        idroom: this.roomId,
      });
      console.log(result);
      this.completedUser = result.countPercent100;
      this.notCompletedUser = result.allUser - result.countPercent100;
      this.totalUser = result.allUser;
      this.userToday = result.onlineToday.countOnline;
      this.totalPercent = result.allUser * 100;
      this.sumPercentProgress = result.sumPercent;
      this.sumPercentProgress = (result.sumPercent * 100) / this.totalPercent;
      this.differencePercent = 100 - this.sumPercentProgress;
      this.series = [this.sumPercentProgress, this.differencePercent];
      this.seriesLearningProgress = [this.completedUser, this.notCompletedUser];

      console.log(
        'completedUser : ',
        typeof this.completedUser,
        result.countPercent100
      );
      console.log(
        'totalUser : ',
        typeof this.totalUser.toFixed(2),
        result.allUser,
        typeof result.allUser
      );
      console.log(
        'sumPercentProgress : ',
        typeof this.sumPercentProgress.toFixed(2)
      );
      this.seriesAngleCircle = [
        ((this.completedUser * 100) / this.totalUser).toFixed(2),
        this.sumPercentProgress.toFixed(2),
      ];
      console.log('seriesAngleCircle : ', this.seriesAngleCircle);
      //   console.log('statistic course : ', result);
      //   console.log('totalPercent : ', this.totalPercent);
      //   console.log('differencePercent : ', this.differencePercent);
      //   console.log('series : ', this.series);
      let arrayGraph = result.arrayGraph;
      this.overallSeries[0].data = [];
      arrayGraph.map((graph) => {
        this.overallSeries[0].data.push([graph.date, graph.countOnline]);
      });
      let newSeries = this.overallSeries[0].data;
      this.overallSeries = [
        {
          data: newSeries,
        },
      ];
      //   console.log('overal series : ', this.overallSeries);
    },
    goToCourseDetail(){
      this.$router.push({
        path: '/course/detail',
        query: {
          id: this.$route.query.id,
          step: 1,
        },
      });
    }
  },
  // beforeMount(){
  //   this.initialize();
  // }
  // async mounted() {
  //   await this.initialize();
  // },
  async beforeMount() {
    await this.initialize();
  },
};
</script>

<style scoped>
.org-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.mb0 {
  margin-bottom: 0px;
}

.editor {
  height: 200px;
  margin-bottom: 70px;
}

.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  /* margin-top: 7%; */
  margin-top: 5px;
}

.headExplan {
  color: red;
  font-size: 20px;
  font-weight: bold;
}

.img {
  float: left;
  margin-right: 1rem;
}

.verticalLine {
  border-left: 3px solid #f5f5f5;
}

.rowCard {
  height: 400px;
  margin-top: 20px;
}

.titleCard {
  font-weight: bold;
  margin-top: 10px;
  color: rgb(0, 0, 0);
}

.logo {
  width: 20%;
  margin: 0 auto;
}

.login-page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.paddingImg {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 60%;
  height: 60%;
}

.paddingCard {
  padding: 5px;
}

.center-div {
  margin: 0 auto;
}

/* .v-select.v-select--is-menu-active .v-input__icon--append .v-icon {
    -webkit-transform: unset;
    transform: unset;
} */
/* .item-card {
  width: 30%;
  min-height: 300px;
} */
@media only screen and (max-width: 768px) {
  /* .item-card {
    width: 100%;
  } */
  .login-page {
    height: 100%;
    align-items: unset;
  }

  .v-application .pa-12 {
    padding: 10px !important;
  }
}

@media only screen and (min-width: 769px) and (max-width: 1024px) {
  /* .item-card {
    width: 60%;
    min-height: 560px;
  } */

  .login-page {
    height: 100%;
    align-items: center;
  }

  .v-application .pa-12 {
    padding: 10px !important;
  }
}
</style>
<style lang="scss" scoped>
.correct {
  color: #4caf50;
  border: 1px solid #4caf50 !important;

  .check {
    position: absolute;
    left: 5px;
    top: 13px;

    i {
      color: #4caf50;
    }
  }

  p {
    color: #4caf50;
  }
}

.incorrect {
  color: #f44336;
  border: 1px solid #f44336 !important;

  .check {
    position: absolute;
    left: 5px;
    top: 13px;

    i {
      color: #f44336;
    }
  }

  p {
    color: #f44336;
  }
}

.page-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.selectCourse {
  height: auto;
}

.fixed-heght {
  height: 30px;
}

.rounded-card {
  border-radius: 8px;
}

/* .v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px;
} */
.v-input__append-inner {
  margin-top: 9px !important;
}

.md-fixed-max-width {
  max-width: 200px;
}

.add-course .full-width {
  width: 100%;
}

.img-padding {
  display: flex;
  align-items: center;
  justify-content: center;
}

.apexcharts-toolbar {
  visibility: hidden;
  display: none;
}

.d-flex {
  display: flex;
}

@media only screen and (max-width: 768px) {
  .hiddex-xs {
    display: none;
  }

  .xs-full-max-width {
    max-width: 100%;
  }

  .md-fixed-width {
    width: 150px;
  }

  .xs-fixed-width {
    width: 100px;
  }

  .table-header {
    height: auto !important;
  }

  .table-header .v-toolbar__content {
    height: auto !important;
    flex-flow: column !important;
    padding: 0 !important;
  }

  .xs-full-width {
    width: 50%;
  }
}

.border-bottom {
  border-bottom: 1px solid #cfd8dc;
}

.border-bottom:last-child {
  border-bottom: none;
}

.full-width {
  width: 100%;
}

.filter-header {
  display: flex;
  justify-content: space-between;
}

.md-border {
  border: 1px solid #bdbdbd;
}

.text-caption {
  color: #9b9b9b;
  text-transform: uppercase;
}

.btn-reload {
  background: #ffffff !important;
  border: 1px solid #d9d9d9;
  color: rgb(77, 77, 77);
  box-shadow: none !important;
}

.hidden-md {
  display: none;
}

.main {
  background-color: rgb(241, 243, 245);
}

.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}

.text-field-border {
  border: 1px solid;
  border-radius: 8px;
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  height: 40px;
  color: rgb(77, 77, 77);
}

.title-text {
  color: rgb(140, 140, 140);
}

.text-primary {
  color: rgb(66, 154, 216) !important;
}

.have-border {
  border: thin solid #e4e4ee;
  border-radius: 4px;
}

.stat-num {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.stat-num-top {
  background-image: linear-gradient(rgba(#0779e4, 1), rgba(#0779e4, 0.7));
  color: white;
}

.stat-num-total {
  background-image: linear-gradient(rgba(#9f4355, 1), rgba(#9f4355, 0.7));
  color: white;
}

.stat-num-today {
  background-image: linear-gradient(rgba(#482f4d, 1), rgba(#482f4d, 0.7));
  color: white;
}

.stat-num-online {
  background-image: linear-gradient(rgba(#699ab2, 1), rgba(#699ab2, 0.7));
  color: white;
}

.stat-num-not-completed {
  background-image: linear-gradient(rgba(#ec0101, 1), rgba(#ec0101, 0.5));
  color: white;
}

.stat-num:hover {
  /* box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19); */
  /* background-color: rgba(#0779e4, 0.4); */
  transform: scale(1.05, 1.05);
}

.graph-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 5px;
  background-color: white;
  transition: transform 0.3s ease-in-out;
}

.graph-card:hover {
  /* box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19); */
  transform: scale(1.02, 1.02);
}

.v-application p {
  margin: 0 !important;
}

.number-border {
  /* padding: 5px; */
  width: 30px;
  height: 30px;
  position: relative;
}

.have-number-border {
  border: 1px solid #bdbdbd;
  border-radius: 20px;
  background: #bdbdbd87;
}

.number {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

p img {
  width: 100% !important;
}

.custom-icon {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  margin-top: 0;
}

.custom-number-panel {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}
</style>
<style>
.custom-question p {
  margin-bottom: 5px !important;
}

p > img {
  width: 100% !important;
}
</style>
